/**
 * UoM Category Constants
 * Categories: Weight, Length, Volume, Count
 */
export const UOM_CATEGORIES = [
  { value: 'Weight', label: 'Weight' },
  { value: 'Length', label: 'Length' },
  { value: 'Volume', label: 'Volume' },
  { value: 'Count', label: 'Count' },
];

/**
 * Get all category names
 */
export const getCategoryNames = (): string[] => {
  return UOM_CATEGORIES.map(cat => cat.value);
};
